// src/components/SidebarSignature/SidebarSignature.jsx
import React from "react";
import styles from "./SidebarSignature.module.css";

export default function SidebarSignature() {
  return (
    <div className={styles.signature}>
      <span className={styles.name}>EZEQUIEL BAMIO</span>
      <span className={styles.year}>© 2025</span>
    </div>
  );
}
